import { useNavigate } from 'react-router-dom'
import { useMatches } from '@/shared/hooks/useMatches'
import { bridge } from '@/shared/bridge'
import { resolveProfileMediaUrl } from '@/shared/lib/resolveProfileMediaUrl'

export function Matches() {
  const navigate = useNavigate()
  const { data: matches, isLoading } = useMatches()

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 flex flex-col">
      {/* Header */}
      <div className="border-b border-gray-200 dark:border-gray-700 p-4 sticky top-0 bg-white dark:bg-gray-900">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Мои мэтчи 💬</h1>
          <button
            onClick={() => navigate('/dashboard')}
            className="text-gray-700 dark:text-gray-200 text-xl font-medium hover:opacity-80"
          >
            ←
          </button>
        </div>
      </div>

      {/* Matches List */}
      <div className="flex-1 overflow-y-auto">
        {isLoading ? (
          <div className="divide-y divide-gray-200 p-4 space-y-4">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="flex items-center gap-3 py-4">
                <div className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse flex-shrink-0" />
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4 animate-pulse" />
                  <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/2 animate-pulse" />
                </div>
              </div>
            ))}
          </div>
        ) : !matches || matches.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-64">
            <p className="text-gray-600 dark:text-gray-400 text-lg mb-4">Нет мэтчей 😔</p>
            <button
              onClick={() => navigate('/dashboard')}
              className="bg-accent text-white px-6 py-2 rounded-full font-semibold hover:opacity-90"
            >
              Начни свайпить →
            </button>
          </div>
        ) : (
          <div>
            {matches.map((match) => {
              return (
                <div
                  key={match.id}
                  className="flex w-full items-center gap-3 border-b border-gray-100 p-4 last:border-0 dark:border-gray-800"
                >
                  <button
                    type="button"
                    onClick={() => navigate(`/matches/${match.id}`)}
                    className="flex min-w-0 flex-1 items-center gap-3 text-left transition-colors hover:opacity-90"
                  >
                    {match.avatar ? (
                      <img
                        src={resolveProfileMediaUrl(match.avatar)}
                        alt=""
                        className="h-16 w-16 shrink-0 rounded-full object-cover ring-1 ring-black/10 dark:ring-white/10"
                      />
                    ) : (
                      <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-accent to-pink-400 text-2xl font-bold text-white">
                        {match.name?.[0]?.toUpperCase() || '?'}
                      </div>
                    )}
                    <div className="min-w-0 flex-1">
                      <h3 className="font-semibold text-gray-900 dark:text-white">
                        {match.name || 'Пользователь'}
                      </h3>
                      <p className="truncate text-sm text-gray-600 dark:text-gray-400">Начни общение</p>
                      <p className="mt-1 text-xs text-gray-500 dark:text-gray-500">
                        {match.lastMessageAt
                          ? new Date(match.lastMessageAt).toLocaleDateString('ru-RU')
                          : 'Новый мэтч'}
                      </p>
                    </div>
                    <span className="shrink-0 text-gray-400">→</span>
                  </button>
                  {match.maxProfileUrl ? (
                    <button
                      type="button"
                      title="Профиль в MAX"
                      onClick={(e) => {
                        e.stopPropagation()
                        bridge.openMaxLink(match.maxProfileUrl!)
                      }}
                      className="shrink-0 rounded-full border border-gray-200 px-3 py-2 text-xs font-semibold text-gray-800 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-100 dark:hover:bg-gray-800"
                    >
                      MAX
                    </button>
                  ) : null}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
